import React from 'react';

import { decimalUpTo } from 'Helpers/currencyFormat';

// IB-677 Phase 2 — shared formatting/loading helpers for the RADIO dashboards.
// Extracted from GeneralRiskDashboard{Risks,Issues,Decisions,Opportunities}.js and
// OverviewDashboard.js, which each re-declared the same `fmt`/`sumCounts`/loading
// spinner locally (PR review: consolidate the duplicated inline helpers).

export const fmt = (value) => decimalUpTo(Number(value) || 0);

// Compact figure for space-constrained bar-end labels (e.g. the department AFC
// chart), mirroring the wireframe's "84.2m" style.
export const compact = (value) => {
    const number = Number(value) || 0;
    const abs = Math.abs(number);

    if (abs >= 1e9) {
        return `${(number / 1e9).toFixed(1)}b`;
    }
    if (abs >= 1e6) {
        return `${(number / 1e6).toFixed(1)}m`;
    }
    if (abs >= 1e3) {
        return `${(number / 1e3).toFixed(1)}k`;
    }

    return `${Math.round(number)}`;
};

export const sumCounts = (counts) => Object.values(counts || {}).reduce((total, value) => total + (Number(value) || 0), 0);

// Whole days between an ISO date string and now (for focus-table age columns).
export const daysSince = (date) => (date ? Math.max(0, Math.floor((Date.now() - new Date(date).getTime()) / 86400000)) : null);

// Number of owners with at least one item counted against them (KPI-strip subtitle,
// e.g. "3 across 2 owners"). PR review (#1060): identical inline copy previously
// duplicated in GeneralRiskDashboard{Risks,Decisions,Issues}.js.
export const ownerCount = (byOwner) => Object.values(byOwner || {}).filter((value) => Number(value) > 0).length;

// Display name for a focus-table row's owner, falling back to a translated
// placeholder when unassigned. PR review (#1060): identical inline copy previously
// duplicated in GeneralRiskDashboard{Decisions,Issues}.js.
export const ownerName = (owner) => (owner ? owner.name || [owner.first_name, owner.last_name].filter(Boolean).join(' ') : $t('No owner'));

export function DashboardLoading() {
    return (
        <div className="row my-2">
            <div className="col-12 d-flex align-items-center justify-content-center text-blue">
                <div
                    className="spinner-border"
                    style={{
                        width: '2rem',
                        height: '2rem',
                    }}
                    role="status"
                >
                    <span className="sr-only">{$t('Loading')}...</span>
                </div>
            </div>
        </div>
    );
}
